import { DateTime, Interval } from "luxon";
import { TeamScheduleAsGroup } from "../groupTeamSchedule.js";

export const isDateInRange = (
  dateRange: Date[],
  resources: TeamScheduleAsGroup,
  timeZone: string
) => {
  const startDate = dateRange.at(0);
  const endDate = dateRange.at(-1);
  if (!startDate || !endDate) {
    return [];
  }
  const checkDate = DateTime.fromJSDate(startDate).setZone(timeZone);
  const checkEndDate = DateTime.fromJSDate(endDate)
    .setZone(timeZone)
    .endOf("day");
  // .plus({ seconds: 1 });

  const dateCheckInterval = Interval.fromDateTimes(checkDate, checkEndDate);

  return resources.map((resource) => {
    const tasks = resource.tasks.filter((date) => {
      const startTime = DateTime.fromISO(date.start_time, {
        // zone: timeZone
      });
      const endTime = DateTime.fromISO(date.end_time, {
        // zone: timeZone
      });
      const interval = Interval.fromDateTimes(startTime, endTime);
      // if (
      //   resource.label?.includes("Dennis") &&
      //   date.display_name.includes("Time")
      // ) {
      //   console.log(
      //     date.display_name,
      //     interval.toString(),
      //     dateCheckInterval.toString(),
      //     dateCheckInterval.contains(startTime) ||
      //       dateCheckInterval.contains(endTime)
      //   );
      // }

      return dateCheckInterval.intersection(interval);
    });
    // console.log(resource.label, tasks);
    return {
      ...resource,
      tasks
    };
  });
};
